import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';
import { defaultMemoize } from 'reselect';

import { Messages } from '../../../../../gen-src/Localize';
import { WorkbookEmbeddedDatasourceFragment } from '../../../../../gen-src/queries';
import { DropdownSelectedItem, dropdownStyle } from '../../../data-catalog-shared';

function createListItems(embeddedDatasources: ReadonlyArray<WorkbookEmbeddedDatasourceFragment>): ListItem[] {
  return embeddedDatasources.map(embeddedDatasource => {
    return {
      value: embeddedDatasource.id,
      content: embeddedDatasource.name || Messages.PermissionsRequired(),
      tooltip: embeddedDatasource.name || Messages.PermissionsRequired()
    };
  });
}

export type WorkbookEmbeddedDatasourceSelectorProps = {
  readonly vizportalUrlId: string;
  readonly selectedEmbeddedDatasource: string;
  readonly embeddedDatasources: ReadonlyArray<WorkbookEmbeddedDatasourceFragment>;
  readonly updateEmbeddedDatasourceSelection: (embeddedDatasourceId: string) => void;
};

export class WorkbookEmbeddedDatasourceSelector extends React.PureComponent<WorkbookEmbeddedDatasourceSelectorProps> {

  private memoizedListItems = defaultMemoize(createListItems);

  private getSelectedDatasourceName(): string {
    const selectedDatasource = this.props.embeddedDatasources.find(ds => ds.id === this.props.selectedEmbeddedDatasource);
    return selectedDatasource && selectedDatasource.name ? selectedDatasource.name : Messages.PermissionsRequired();
  }

  public override render(): JSX.Element {
    const listItems = this.memoizedListItems(this.props.embeddedDatasources);
    const selectedDatasourceName = this.getSelectedDatasourceName();
    return (
      <SingleSelectDropdown
        label={''}
        list={
          <List
            items={listItems}
            selectedValue={this.props.selectedEmbeddedDatasource}
          />
        }
        type={DropdownButtonType.Outline}
        value={this.props.selectedEmbeddedDatasource}
        onChange={this.props.updateEmbeddedDatasourceSelection}
        style={dropdownStyle}
      >
        <DropdownSelectedItem title={selectedDatasourceName}>{selectedDatasourceName}</DropdownSelectedItem>
      </SingleSelectDropdown>
    );
  }
}
